/*
 * Copyright (c) Worldline 2023.
 */

export class AppEvent<T> {
    constructor(
        public name: string,
        public data: T,
    ) {
    }
}